import { server } from "../api";
import axios from "axios";
// 修正 deleteField 函數
const deleteField = async (field_id) => {
  try {
    const requestData = { fieldID: field_id };
    const url = server + "field/delete";
    
    // console.log("deleteField 調試信息:");
    // console.log("- field_id 參數:", field_id);
    // console.log("- field_id 類型:", typeof field_id);
    // console.log("- field_id 是否為 undefined:", field_id === undefined);
    // console.log("- field_id 是否為 null:", field_id === null);
    // console.log("- 請求 URL:", url);
    // console.log("- 請求數據:", requestData);
    // console.log("- 完整的請求數據字串:", JSON.stringify(requestData));
    // console.log("- server 變量值:", server);
    
    // 檢查 field_id 是否有效
    if (field_id === undefined || field_id === null || field_id === '') {
      throw new Error(`無效的 field_id: ${field_id}`);
    }
    
    const response = await axios.post(url, requestData);
    
    console.log("deleteField 成功回應:", response.data);
    return response.data; // 返回響應數據
  } catch (err) {
    console.error("deleteField 錯誤詳情:");
    console.error("- 錯誤對象:", err);
    console.error("- 錯誤訊息:", err.message);
    console.error("- 錯誤狀態碼:", err.response?.status);
    console.error("- 錯誤狀態文字:", err.response?.statusText);
    console.error("- 錯誤回應數據:", err.response?.data);
    console.error("- 錯誤配置:", err.config);
    console.error("- 請求 URL:", err.config?.url);
    console.error("- 請求方法:", err.config?.method);
    console.error("- 請求數據:", err.config?.data);
    console.error("- 請求頭:", err.config?.headers);
    
    return err.response?.data || { code: 500, message: "刪除失敗" }; // 處理錯誤
  }
};

const GetFieldData = async (field_id, level) => {
  try {
    const response = await axios.get(server + "field/data", {
      params: {
        field_id,
        level,
      },
    });
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
const UpdateField = async (
  field_id,
  field,
  manager,
  report_line_id,
  warning_line_id,
  server_line_id,
  notification_mode = 0,
  text_notification_channels = null,
  image_notification_channels = null,
  server_notification_channels = null
) => {
  try {
    const requestData = {
      field_id,
      field,
      manager,
      report_line_id,
      warning_line_id,
      server_line_id,
      notification_mode,
      text_notification_channels,
      image_notification_channels,
      server_notification_channels,
    };
    
    const url = server + "field/update";
    
    // console.log("UpdateField 調試信息:");
    // console.log("- 所有參數:");
    // console.log("  field_id:", field_id, "(類型:", typeof field_id, ")");
    // console.log("  field:", field, "(類型:", typeof field, ")");
    // console.log("  manager:", manager, "(類型:", typeof manager, ")");
    // console.log("  report_line_id:", report_line_id, "(類型:", typeof report_line_id, ")");
    // console.log("  warning_line_id:", warning_line_id, "(類型:", typeof warning_line_id, ")");
    // console.log("  server_line_id:", server_line_id, "(類型:", typeof server_line_id, ")");
    // console.log("  notification_mode:", notification_mode, "(類型:", typeof notification_mode, ")");
    // console.log("  text_notification_channels:", text_notification_channels, "(類型:", typeof text_notification_channels, ")");
    // console.log("  image_notification_channels:", image_notification_channels, "(類型:", typeof image_notification_channels, ")");
    // console.log("  server_notification_channels:", server_notification_channels, "(類型:", typeof server_notification_channels, ")");
    // console.log("- 請求 URL:", url);
    // console.log("- 完整請求數據:", requestData);
    // console.log("- 請求數據 JSON:", JSON.stringify(requestData, null, 2));
    // console.log("- server 變量值:", server);
    
    // 檢查必要參數
    if (!field_id) {
      console.warn("UpdateField 警告: field_id 為空");
    }
    if (!field) {
      console.warn("UpdateField 警告: field (場域名稱) 為空");
    }
    if (!manager) {
      console.warn("UpdateField 警告: manager 為空");
    }
    
    const response = await axios.post(url, requestData);
    
    console.log("UpdateField 成功回應:", response.data);
    return response.data;
  } catch (err) {
    console.error("UpdateField 錯誤詳情:");
    console.error("- 錯誤對象:", err);
    console.error("- 錯誤訊息:", err.message);
    console.error("- 錯誤狀態碼:", err.response?.status);
    console.error("- 錯誤狀態文字:", err.response?.statusText);
    console.error("- 錯誤回應數據:", err.response?.data);
    console.error("- 錯誤配置:");
    console.error("  - URL:", err.config?.url);
    console.error("  - 方法:", err.config?.method);
    console.error("  - 請求數據:", err.config?.data);
    console.error("  - 請求頭:", err.config?.headers);
    
    // 如果是 400 錯誤，額外顯示更多信息
    if (err.response?.status === 400) {
      console.error("400 錯誤詳細分析:");
      console.error("- 這通常表示請求參數有問題");
      console.error("- 檢查是否有必要參數缺失或格式錯誤");
      console.error("- 伺服器回應訊息:", err.response?.data?.message || err.response?.data);
    }
    
    throw err; // 重新拋出錯誤，讓調用方處理
  }
};
const CreateField = async (
  field,
  manager_id,
  report_line_id,
  warning_line_id,
  server_line_id,
  notification_mode = 0,
  text_notification_channels = null,
  image_notification_channels = null,
  server_notification_channels = null
) => {
  const response = await axios.post(server + "field/create", {
    field,
    manager_id,
    report_line_id,
    warning_line_id,
    server_line_id,
    notification_mode,
    text_notification_channels,
    image_notification_channels,
    server_notification_channels,
  });
  return response.data;
};
export default { GetFieldData, CreateField, UpdateField, deleteField };
